var React = require('react');

function Card (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"21.9991","cy":"22","r":"17","fill":"#09856A","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.3367 18.625C16.3367 18.2936 16.6053 18.025 16.9367 18.025H27.0617C27.393 18.025 27.6617 18.2936 27.6617 18.625V20.35H16.3367V18.625ZM15.2867 20.875V18.625C15.2867 17.7137 16.0254 16.975 16.9367 16.975H27.0617C27.9729 16.975 28.7117 17.7137 28.7117 18.625V20.875V25.375C28.7117 26.2862 27.9729 27.025 27.0617 27.025H16.9367C16.0254 27.025 15.2867 26.2862 15.2867 25.375V20.875ZM27.6617 21.4V25.375C27.6617 25.7063 27.393 25.975 27.0617 25.975H16.9367C16.6053 25.975 16.3367 25.7063 16.3367 25.375V21.4H27.6617Z","fill":"white","key":1})]);
}

Card.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Card;

Card.default = Card;
